import { TypeStatsDataPoint } from '../library/regression.interface';
import { StatsRegression } from './regression';


/**------------------------------------------------------
 * Curve Analyzer
 */
export class StatsCurveAnalyzer {

	constructor(
		private regression: StatsRegression
	) {}


	/**------------------------------------------------------
	 * ToDo List
	 */
	// movingAverage();
	// powerFit();
	// savitzkyGolayFilter();		// cspell:disable-line
	// concavity();

	// trendFit();


	/**------------------------------------------------------
	 * Trend Analyzer
	 */

	//** Linear Concavity */
	linearConcavity(regressionCoefficient: number[]): number {
		const df: number = regressionCoefficient[0];
		return df;
	}

	//** Trend Analysis */
	trendFit(dataPoints: TypeStatsDataPoint[]): EnumStatsTrendFit {

		//0 - calculate the concavity
		const regressionCoefficient: number[] = this.regression.linearFit(dataPoints).equation;
		const concavity			   : number	  = this.linearConcavity(regressionCoefficient);

		//1 - calculate the trend
		const trend: EnumStatsTrendFit = this.getTrend(concavity);
		return trend;
	}

	//** Moving Average */
	movingAverage(timeSeriesData: IStatsTimeSeriesData[]): IStatsTimeSeriesData[] {
		const avgSeriesData: IStatsTimeSeriesData[] = timeSeriesData.map((seriesData: IStatsTimeSeriesData, index: number) => ({
			time: new Date(seriesData.time).getTime(),
			value: this.computeMovingAverage(timeSeriesData, seriesData.value || 0, index)
		}));
		return avgSeriesData;
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private getTrend(concavity: number, threshold: number = 0.1) {
		if (concavity >= -threshold && concavity <= threshold) return EnumStatsTrendFit.Consistent;
		if (concavity > threshold) 	return EnumStatsTrendFit.Uptrend;
		if (concavity < -threshold) return EnumStatsTrendFit.Downtrend;
		throw new Error(`CurveAnalyzerHelper => getTrend => FATAL ERROR: no match found (please update code here)`);
	}

	private computeMovingAverage(timeSeriesData: IStatsTimeSeriesData[], currentValue: number, currentIndex: number, movingAveragePeriod: number = 2): number {

		//0 - iterate and find previous and next values
		const interests	: number[] = [currentValue];
		for (let i: number = 1; i <= movingAveragePeriod; i++) {

			//a. get previous value
			interests.push(timeSeriesData[currentIndex - i]?.value || currentValue);

			//b. get next value
			interests.push(timeSeriesData[currentIndex + i]?.value || currentValue);
		}

		//1 - compute average
		const average: number = interests.reduce((x: number, y: number) => x + y, 0) / interests.length;
		return average;
	}
}


//** Enums -------------------------------------- */
export enum EnumStatsTrendFit {
	Uptrend 		= 'uptrend',
	Downtrend 		= 'downtrend',
	SeasonalTrend 	= 'seasonal_trend',
	Consistent	 	= 'consistent'
}

//** Interfaces --------------------------------- */
export interface IStatsTimeSeriesData {
	time	: number;
	value	: number;
}
